export const assignSelect = (state, action) => (Object.assign({}, state, { selectedValue: action.payload }));
export const resetSelect = (state) => (Object.assign({}, state, { selectedValue: state.defaultSelectedValue }));
export const assignMultiSelect = (state, action) => (Object.assign({}, state, { selectedValues: action.payload }));
export const resetMultiSelect = (state) => (Object.assign({}, state, { selectedValues: state.defaultSelectedValues }));

export const loadSelect = filterName => (state, action) => {
  return Object.assign({}, state, { selectedValue: action.payload.filters[filterName].selectedValue });
};

export const loadMultiSelect = filterName => (state, action) => {
  return Object.assign({}, state, { selectedValues: action.payload.filters[filterName].selectedValues });
};
